import { render, staticRenderFns } from "./SetEmail.vue?vue&type=template&id=596591ec&scoped=true"
import script from "./SetEmail.vue?vue&type=script&lang=js"
export * from "./SetEmail.vue?vue&type=script&lang=js"
import style0 from "./SetEmail.vue?vue&type=style&index=0&id=596591ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596591ec",
  null
  
)

export default component.exports